/**
 * @generated SignedSource<<55aba94e0ae1528dadaeb7030f232a01>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignalWorkspaceTemplateSelector_workspace$data = {
  readonly id: string;
  readonly signalTemplates: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"SignalWorkspaceTemplateSelectorTemplateItem_SignalWorkspaceTemplate">;
  }>;
  readonly " $fragmentType": "SignalWorkspaceTemplateSelector_workspace";
};
export type SignalWorkspaceTemplateSelector_workspace$key = {
  readonly " $data"?: SignalWorkspaceTemplateSelector_workspace$data;
  readonly " $fragmentSpreads": FragmentRefs<"SignalWorkspaceTemplateSelector_workspace">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SignalWorkspaceTemplateSelector_workspace",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SignalWorkspaceTemplate",
      "kind": "LinkedField",
      "name": "signalTemplates",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SignalWorkspaceTemplateSelectorTemplateItem_SignalWorkspaceTemplate"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Workspace",
  "abstractKey": null
};
})();

(node as any).hash = "eb6a3a6505531131f80c831ec87fc6ad";

export default node;
